import * as React from "react";
const SCRIPT_URL = "https://cloud.wordlift.io/app/bootstrap.js";
function WordLift({ ScriptComponent, isWordLiftScriptEnabled }) {
  if (!isWordLiftScriptEnabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(ScriptComponent, { async: true, type: "text/javascript", strategy: "afterInteractive", src: SCRIPT_URL });
}
export {
  SCRIPT_URL,
  WordLift
};
//# sourceMappingURL=wordlift.js.map
